import { StatusTextProps } from './statusText.interface';
import * as S from './statusText.styles';

const StatusText = ({ color, children, className = '' }: StatusTextProps) => (
  <S.Wrapper $statusColor={color} className={className}>
    {children}
  </S.Wrapper>
);

export default StatusText;
